import { useQuery } from "@tanstack/react-query";
import { clientAPI } from "../../api/client";

async function fetchConstantData() {
  const searchOptions = {
    limit: 10000000,
    page: 1,
  };

  // if (projectId){
  //   searchOptions.status = 'OPEN';
  // }
  const searchQueryParams = new URLSearchParams(searchOptions).toString();
  let searchQueryEmployeeDepartment = new URLSearchParams({
    ...searchOptions,
    status: 0,
  }).toString();
  // Fetch constant data concurrently
  const [investor, city, projectType, employee, agent, designBanner] =
    await Promise.all([
      clientAPI("get", `/investor?${searchQueryParams}`),
      clientAPI("get", `/city?${searchQueryParams}`),
      clientAPI("get", `/projectType?${searchQueryParams}`),
      clientAPI("get", `/employee?${searchQueryEmployeeDepartment}`),
      clientAPI("get", `/agent?${searchQueryParams}`),
      clientAPI("get", `/designBanner/background?${searchQueryParams}`),
    ]);

  const designBackgroundType = {
    items: [
      {
        _id: "BOOKING",
        name: "BOOKING",
      },
      {
        _id: "LOCKING",
        name: "LOCKING",
      },
      {
        _id: "HDMB",
        name: "HDMB",
      },
      {
        _id: "TTKQ",
        name: "TTKQ",
      },
    ],
  };

  // Index data by 'id' to improve lookup performance
  return {
    investor: investor?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    city: city?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    projectType: projectType?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    employee: employee?.items?.reduce(
      (acc, item) => ({
        ...acc,
        [item._id]: {
          fullName: item.fullName,
          code: item.code,
        },
      }),
      {}
    ),

    agent: agent?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    designBanner: designBanner?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    designBackgroundType: designBackgroundType?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
  };
}

export function useCategories(shouldFetch) {
  // Fetch constant data once
  const {
    data: constantData,
    isLoading,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["categories14"],
    queryFn: () => fetchConstantData(),
    enabled: shouldFetch,
    refetchOnWindowFocus: false,
  });

  return {
    constantData,
    isLoading,
    isFetching,
    refetch,
  };
}
